module.exports = __webpack_public_path__ + "static/media/logo-footer.24e96777.svg";